module.exports = __webpack_public_path__ + "static/media/2011 - 12 Daniel Lo-min.a977e499.jpg";